// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    COMPANY_PAGE_LOADING() {
      return {
        isLoading: true,
        companyPage: action.companyPage
      };
    },
    COMPANY_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.companyPage
      };
    },
    COMPANY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.companyPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
